export const FINANCE_EVENTS = {
  FITTING: 'FITTING',
  REIMBURSEMENT: 'REIMBURSEMENT',
  REFERRAL: 'REFERRAL',
  RETAINER: 'RETAINER',
  CONSULTATION: 'CONSULTATION',
  WHITENING: 'WHITENING'
};

export const FINANCE_EVENTS_LABELS: Record<string, string> = {
  fittings: 'event.fittings',
  reimbursements: 'event.reimbursements',
  referrals: 'event.referrals',
  retainers: 'event.retainers',
  consultations: 'event.consultations',
  whitenings: 'event.whitening'
};

export const FINANCE_EVENTS_LIST = [
  {
    label: 'event.fittings',
    value: FINANCE_EVENTS.FITTING
  },
  {
    label: 'event.reimbursements',
    value: FINANCE_EVENTS.REIMBURSEMENT
  },
  {
    label: 'event.referrals',
    value: FINANCE_EVENTS.REFERRAL
  },
  {
    label: 'event.retainers',
    value: FINANCE_EVENTS.RETAINER
  },
  {
    label: 'event.consultations',
    value: FINANCE_EVENTS.CONSULTATION
  },
  {
    label: 'event.whitening',
    value: FINANCE_EVENTS.WHITENING
  }
];
export const DEFAULT_FINANCE_SUMMARY: Record<string, string> = {
  consultations: '0',
  fittings: '0',
  referrals: '0',
  retainers: '0',
  whitenings: '0',
  reimbursements: '0'
};
export const FINANCE_SUMMARY_STATUS = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PENDING_CONFIRMATION: 'PENDING_CONFIRMATION',
  PENDING_PROPOSAL_SYNC: 'PENDING_PROPOSAL_SYNC',
  INVOICE_COMPLETED: 'INVOICE_COMPLETED',
  APPROVED: 'APPROVED'
};
export const ACTION_DISABLED_STATUSES = [
  FINANCE_SUMMARY_STATUS.PENDING_CONFIRMATION,
  FINANCE_SUMMARY_STATUS.APPROVED,
  FINANCE_SUMMARY_STATUS.INVOICE_COMPLETED
];

export const FINANCE_PENDING_STATUSES = [
  FINANCE_SUMMARY_STATUS.PENDING_APPROVAL,
  FINANCE_SUMMARY_STATUS.PENDING_CONFIRMATION,
  FINANCE_SUMMARY_STATUS.PENDING_PROPOSAL_SYNC
];

export const PRODUCT_TYPES = {
  ZENYUM_CLEAR: 'ZenyumClear™',
  ZENYUM_CLEAR_PLUS: 'ZenyumClear™ Plus',
  ZENYUM_CLEAR_EXTRA: 'ZenyumClear™ Extra',
  REFINEMENT: 'Refinement',
  RETAINER: 'Retainer'
};

export const productTypeList = [
  {
    label: 'product_type.zenyum_clear',
    value: PRODUCT_TYPES.ZENYUM_CLEAR
  },
  {
    label: 'product_type.zenyum_clear_plus',
    value: PRODUCT_TYPES.ZENYUM_CLEAR_PLUS
  },
  {
    label: 'product_type.zenyum_extra',
    value: PRODUCT_TYPES.ZENYUM_CLEAR_EXTRA
  },
  {
    label: 'product_type.refinement',
    value: PRODUCT_TYPES.REFINEMENT
  },
  {
    label: 'product_type.retainer',
    value: PRODUCT_TYPES.RETAINER
  }
];

export const ADD_QUOTE_VISIBLE_STATUSES = [
  FINANCE_SUMMARY_STATUS.PENDING_APPROVAL,
  FINANCE_SUMMARY_STATUS.PENDING_PROPOSAL_SYNC
];

export const FINANCE_EVENT_LABELS: Record<string, string> = {
  FITTING: 'event.fittings',
  REIMBURSEMENT: 'event.reimbursements',
  REFERRAL: 'event.referrals',
  RETAINER: 'event.retainers',
  CONSULTATION: 'event.consultations',
  WHITENING: 'event.whitening'
};

export const ACTION_TEXT_MAP: Record<string, string> = {
  Edit: 'updated.updated',
  Delete: 'deleted.deleted',
  Add: 'added.added'
};

export const FINANCE_GUIDE_STEPS = [
  {
    target: '#ADD_QUOTE',
    title: 'create.an.entry',
    disableBeacon: true,
    content: 'create.entry.description',
    placement: 'bottom'
  },
  {
    target: '#QUOTE_ACTIONS',
    title: 'manage.entry',
    disableBeacon: true,
    content: 'manage.entry.description'
  }
];

export const BUSINESS_ACCOUNT_STATEMENT_STATUSES = [
  {
    label: 'status.pending_approval',
    value: FINANCE_SUMMARY_STATUS.PENDING_APPROVAL
  },
  {
    label: 'status.pending_confirmation',
    value: FINANCE_SUMMARY_STATUS.PENDING_CONFIRMATION
  },
  {
    label: 'status.pending_invoice',
    value: FINANCE_SUMMARY_STATUS.APPROVED
  }
];

export const TW_TAX_WITHDRAWAL_THRESHOLD = 20000;
